<template>
    <div class="application-form-field">
        <component
            v-if="getComponentForFieldType(field.type)"
            :is="getComponentForFieldType(field.type)"
            v-model="internalValue"
            :label="$tc(`applicationsFields.${field.name}`)"
            :help="$tc(`applicationFieldHelp.${field.name}`)"
            :type="field.inputType"
            :textObjectType="field.type"
            :placeholder="$tph(`applicationsFields.placeholders.${dataModel}.${field.name}`)"
            :required="field.required"
            :disabled="field.disabled"
            :options="formattedSelectOptions"
            :items="field.values"
            :itemsLabels="translatedItemsLabels"
            :imagesList="field.imagesList"
        >
        </component>
        <div class="application-form-field__errors">
            <div v-for="(error, index) in errors" :key="index" class="application-form-field__error-message">
                {{ $tc(`formErrors.${error.errorMessageKey}`) }}
            </div>
        </div>
    </div>
</template>
<script>
import {FormMultiCheckboxGroup, SahInput, FormTextareaGroup, FormSelectGroup, mixins} from "atom";
import FormTextObjectGroup from "./FormTextObjectGroup";
import FormTextObjectsListGroup from "./FormTextObjectsListGroup";
import ImagePickerGroup from "@/components/ImagePickerGroup";
import IconFormField from "@/components/IconFormField";
import {COMPONENT_FOR_FIELD_TYPE} from "../constants";

const {Proxyable} = mixins;

export default {
    name: "application-form-field",
    mixins: [Proxyable],
    props: {
        dataModel: {type: String, default: ""},
        errors: {type: Array},
        field: {type: Object, required: true},
    },
    components: {
        SahInput,
        FormTextareaGroup,
        FormSelectGroup,
        FormMultiCheckboxGroup,
        FormTextObjectGroup,
        FormTextObjectsListGroup,
        IconFormField,
        ImagePickerGroup,
    },
    computed: {
        formattedSelectOptions() {
            let options = [];
            if (this.field.type === "select" && this.field.values && this.field.values.length) {
                options = this.field.values.map(element => ({text: element, value: element}));
            }
            options.unshift({text: this.$tc("words.select"), value: null, disabled: true});
            return options;
        },
        translatedItemsLabels() {
            let labels = {};
            if (this.field.type === "list" && this.field.values && this.field.values.length) {
                for (let item of this.field.values) {
                    labels[item] = this.$tph(`${this.field.name}.${item}`, item);
                }
            }
            return labels;
        },
        hasError: function() {
            return this.errors?.length;
        },
    },
    watch: {
        internalValue: {
            handler(newValue) {
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },
    methods: {
        getComponentForFieldType(fieldType) {
            return COMPONENT_FOR_FIELD_TYPE[fieldType];
        },
    },
};
</script>
<style lang="scss" scoped>
.application-form-field::v-deep {
    @apply w-full;
    .application-form-field__errors {
        @apply mt-1;
        min-height: $form-field-errors-min-height;
    }
    .application-form-field__error-message {
        @apply text-left mb-2;
        color: $text-error-color;
        font-size: $error-message-font-size;
    }
}
</style>
